export default {
  white: "#fff",
  primary: { blue: "#20356D", gray: "#B1B1B1" },
  secondary: { blue: "#effbff", gray: "#F0F1F5" },
  tertiary: { blue: "#AAE8FF", gray: "#F7F7F7" },
  quaternary: { blue: "#D1F1FC", gray: "#DBDBDB" },
};
